/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateThermoformingBaseStockDto } from '../../models/create-thermoforming-base-stock-dto';
import { ThermoformingBaseStock } from '../../models/thermoforming-base-stock';

export interface CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params {
      body: CreateThermoformingBaseStockDto
}

export function createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingBaseStock>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingBaseStock>;
    })
  );
}

createOneBaseMgmtThermoformingBaseStockControllerThermoformingBaseStock.PATH = '/api/mgmt/thermoforming-base-stock';
